<template>
  <div class="middle-view view-wrapper view-wrapper-middle">
    <div class="view-middle">
      <div class="text-center">
        <img src="@/assets/404.png" alt="404" class="header-image" />
        <h1 v-translate>404 - Page not found</h1>
        <p class="pb-3" v-translate>we couldn't find the page you are looking for</p>
        <router-link :to="{ path: '/loading' }" class="btn btn-primary" v-translate>Back home</router-link>
      </div>
    </div>
  </div>
</template>

<script setup></script>

<style lang="scss" scoped>
.middle-view {
  .header-image {
    max-width: 100%;
    height: 400px;
    object-fit: contain;
  }
}
</style>
